import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class Voxintar {

	ff: number;
	ss: number;

	constructor() {
		this.con(128, 1000);
	}

	con( ff, ss ) {
		this.ff = ff / 32;
		this.ss = ss;
	}

	insta( salt, xx ) {
		var key = CryptoJS.PBKDF2(
			xx,
			CryptoJS.enc.Hex.parse(salt), { keySize: this.ff, iterations: this.ss });
		return key;
	}

	pum( salt, iv, xx, tt ) {
		var key = this.insta(salt, xx);
		var encrypted = CryptoJS.AES.encrypt(
			tt,
			key, { iv: CryptoJS.enc.Hex.parse(iv) });
		return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
	}

	inari( tt ) {
		let gg = "";
		let insta = "J#mK;8CU*6t=y@q%";

		if (tt) {
			if (tt !== "") {
				if (tt.length > 0) {
					let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
					let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
					let zz = this.pum(salt, iv, insta, tt);
					gg = (iv + "::" + salt + "::" + zz);
					gg = btoa(gg);
				}
			}
		}

		return gg;
	}
}